import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode:'history',
  
  routes: [
    {
      path:'/',
      component: resolve => require(['../view/account/login.vue'],resolve),
         
    },
    {
      path:'/login',
      name:'login',
      component: resolve => require(['../view/account/login.vue'],resolve),
      meta:{loadDict:true}   
    },
    {
      path:'/logins',
      redirect: { name: 'login' },
      component: resolve => require(['../view/account/login.vue'],resolve),
      meta:{loadDict:true}    
    },
    {
      path:'/home',
      name:'home',
      component: resolve => require(['../view/videoText/index.vue'],resolve),
      meta:{loadDict:true}   
    },
    {
      path:'/faceRecognition',
      name:'faceRecognition',
      component: resolve => require(['../view/account/faceRecognition.vue'],resolve),
      meta:{requireAuth:true}   
    },    {
      path:'/faceRecognitionText',
      name:'faceRecognitionText',
      component: resolve => require(['../view/account/faceRecognitionText.vue'],resolve),
      meta:{requireAuth:true}   
    },

    {
      path:'/subscribe',
      name:'subscribe',
      component: resolve => require(['../view/home/subscribe.vue'],resolve),
      meta:{requireAuth:true}   
    },    
    {
      path:'/paperDes',
      name:'paperDes',
      component: resolve => require(['../view/home/paperDes.vue'],resolve),
      meta:{requireAuth:true}   
    },       
    {
      path:'/examCoach',
      name:'examCoach',
      component: resolve => require(['../view/examCoach/examCoach.vue'],resolve),
      meta:{requireAuth:true}   
    },
    {
      path:'/personInfo',
      name:'personInfo',
      component: resolve => require(['../view/personInfo/personInfo.vue'],resolve),
      meta:{requireAuth:true}   
    },
    {
      path:'/achievementSearch',
      name:'achievementSearch',
      component: resolve => require(['../view/achievementSearch/achievementSearch.vue'],resolve),
      meta:{requireAuth:true}   
    },
    {
      path:'/examTesting',
      name:'examTesting',
      component: resolve => require(['../view/examTesting/examTesting.vue'],resolve),
      meta:{requireAuth:true}   
    },
    {
      path:'/videoText',
      name:'videoText',
      component: resolve => require(['../view/examTesting/videoText.vue'],resolve),
      meta:{requireAuth:true}   
    },
    {
      path:'/onlineExam',
      name:'onlineExam',
      component: resolve => require(['../view/onlineExam/newOnlineExam.vue'],resolve),
      // meta:{title:'在线考试',requireAuth:true}   
    },    {
      path:'/beforeExam',
      name:'beforeExam',
      component: resolve => require(['../view/onlineExam/beforeExam.vue'],resolve),
      // meta:{title:'在线考试',requireAuth:true}   
    },
    // {
    //   path:'/newOnlineExam',
    //   name:'newOnlineExam',
    //   component: resolve => require(['../view/onlineExam/newOnlineExam.vue'],resolve),
    //   // meta:{title:'在线考试',requireAuth:true}   
    // },
    // {
    //   path:'/indexText',
    //   name:'indexText',
    //   component: resolve => require(['../view/videoText/index.vue'],resolve),
    //   meta:{loadDict:true}   
    // },
    {
      path:'/videoTip',
      name:'videoTip',
      component: resolve => require(['../view/videoText/videoTip.vue'],resolve),
      meta:{loadDict:true}   
    },
    {
      path:'/camera',
      name:'camera',
      component: resolve => require(['../view/videoText/camera.vue'],resolve),
      meta:{loadDict:true}   
    },
    {
      path:'/recardVideo',
      name:'recardVideo',
      component: resolve => require(['../view/videoText/recardVideo.vue'],resolve),
      meta:{loadDict:true}   
    },
    {
      path:'/authComfirm',
      name:'authComfirm',
      component: resolve => require(['../view/personInfo/authComfirm.vue'],resolve),
      meta:{loadDict:true}   
    },
    {
      path:'/stream',
      name:'stream',
      component: resolve => require(['../view/stream.vue'],resolve),
      meta:{requireAuth:true}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js